@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ChartLegend {
  @extend %font-family-primary;

  font-size: smaller;
  margin: 0;
  padding: 0;
  width: 100%;

  li {
    border-top: 1px solid $theme-color-borders;
    color: $theme-color-text;
    display: table;
    list-style-type: none;
    width: 100%;
    padding: 2.5px;

    &:last-child {
      border-bottom: 1px solid $theme-color-borders;
    }
  }

  span {
    display: table-cell;
  }

  .amount {
    text-align: right;
    width: 5em;
  }

  .colorTag {
    vertical-align: middle;
    width: 3em;
  }

  .label {
    padding-left: 0.5em;
    text-align: left;
  }
}
